import axios from 'axios'
import { AI_CHAT_API_URL } from './constants/config'

export default axios.create({
  baseURL: AI_CHAT_API_URL
})
